import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=5b8a688f&scoped=true"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"
import style0 from "./TopMenu.vue?vue&type=style&index=0&id=5b8a688f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8a688f",
  null
  
)

export default component.exports